import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Inlined so the Telnyx client stays out of the admin bundle; the handler
 *  passes this straight to `rcsTestPayload`, so drift fails to compile. */
export const RCS_TEST_PAYLOADS = ["text", "chips", "card", "carousel"] as const;

export type RcsTestPayloadOption = (typeof RCS_TEST_PAYLOADS)[number];

/**
 * Reports the gate, the probe and the send as three separate facts. Collapsing
 * them is what makes a pre-launch test look like a pass.
 */
export const sendTestRcs = {
  name: "sendTestRcs" as const,
  input: z.object({
    teamId: zExt.objectId(),
    phoneNumber: z.string().trim().min(1),
    payload: z.enum(RCS_TEST_PAYLOADS),
    imageUrl: z.string().trim().url().optional(),
  }),
  output: z.object({
    agentId: z.string().nullable(),
    /** Why the production path would or wouldn't route this team over RCS. */
    gateOutcome: z.enum([
      "resolved",
      "no_account",
      "no_agent_id",
      "merchant_disabled",
      "legacy_marketing_split",
      "lookup_failed",
    ]),
    /** Advisory only — the send runs regardless, which is the point. */
    capability: z.object({
      capable: z.boolean(),
      features: z.array(z.string()),
    }),
    send: z.object({
      attempted: z.boolean(),
      ok: z.boolean(),
      messageId: z.string().optional(),
      error: z.string().optional(),
    }),
  }),
};
